export default __webpack_public_path__ + "static/media/Ring of Iron Skin.97afc3a8.jpg";